










































import {Component, Prop, Vue} from "vue-property-decorator";
import {UserTracksList} from "../types/UserTracks";
import {Agora} from "../agora/Agora";
import {UserProfilesService} from "../data/UserProfilesService";
import VideoStream from "@share/web-conferences/components/VideoStream.vue";
import {Volumes} from "@share/web-conferences/types/Volumes";
import Reconnecting from "@share/web-conferences/components/Reconnecting.vue";
import {findSharingTrackIndex} from "@share/web-conferences/helpers/IsShareScreen";
import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {SharingTypes} from "@api/enums/WebConferenceSlides/SharingTypes";
import Presentation from "@share/presentation/Presentation.vue";
import {stateKey as stateKeyFn} from "@share/web-conferences/helpers/StateKey";
import {runTimeoutForCurrentPresentation} from "@share/web-conferences/helpers/slides/CurrentPresentationAbsenceHandler";
import { AgoraNetworkQualityInterface } from "../interfaces/AgoraQualityCheckerInterface";
import { UID } from "agora-rtc-sdk-ng";

@Component({
  name: "Stage",
  components: {Presentation, Reconnecting, VideoStream}
})
export default class Stage extends Vue {
    @Prop({required: true}) agora: Agora;
    @Prop({required: true}) userProfilesService: UserProfilesService;
    @Prop({required: true}) tracks: UserTracksList;
    @Prop({required: true}) volumes: Volumes;
    @Prop({default: false}) isReconnecting: boolean;
    @Prop({required: true}) webConferenceService: WebConferenceService;
    @Prop({required: true}) networkQuality: AgoraNetworkQualityInterface | null;
	
	getUserQuality(trackUid: UID) {
        return this.networkQuality?.remoteUsersQuality?.[trackUid];
    }

    get totalTracksNumber(): number {
        return Object.keys(this.tracksToShow ?? {}).length;
    }

    get tracksToShow() {
        return Object.values(this.tracks).filter(item => !item.isScreenShare);
    }

    get isThereSharing() {
        return this.webConferenceService.webConferenceData?.isSharing();
    }

    get isThereScreenSharing() {
        return findSharingTrackIndex(this.tracks ?? {}) >= 0;
    }

    get screenSharingTracks() {
        return Object.values(this.tracks ?? {}).find(item => item.isScreenShare);
    }

    get isSharingSlides() {
        return this.webConferenceService.webConferenceData?.hasSharingType(SharingTypes.Slides);
    }

    get currentPresentation() {
        return this.webConferenceService.webConferenceData?.currentPresentation;
    }

    get stateKey() {
        return stateKeyFn(this.webConferenceService.schemaId, this.webConferenceService.objectId);
    }

    async onSlideChange(fileId: string) {
        await this.webConferenceService.changeSlide(fileId);
        // this.webConferenceService.changeCurrentPresentation()
    }

    mounted() {
        runTimeoutForCurrentPresentation(this.webConferenceService, this.$store);
    }
}
